import React, { useState, Suspense } from 'react'
import avatar from '../../../assets/img/icon/avgGroup.png'
import all from '../../../assets/img/icon/q-w1.png'
import q2 from '../../../assets/img/icon/q-2.png'
import q3 from '../../../assets/img/icon/q-3.png'
import q4 from '../../../assets/img/icon/q-4.png'
import faqArray from '../../../assets/dummy'
import QuestionDetail from '../../ContentWithIcon'

const tags = [
  { name: 'Бүгд', img: all, img2: q2 },
  { name: 'Эсийн банк', img: all, img2: q2 },
  { name: 'Эсийн эмчилгээ', img: all, img2: q3 },
  { name: 'Генетик шинжилгээ', img: all, img2: q4 }
]
const questions = faqArray

const FAQSection = () => {
  const [selectedTag, setSelectedTag] = useState('Бүгд')
  const [openQuestionIndex, setOpenQuestionIndex] = useState(null)

  const handleToggle = index => {
    setOpenQuestionIndex(prevIndex => (prevIndex === index ? null : index))
  }
  const filteredQuestions =
    selectedTag === 'Бүгд'
      ? questions
      : questions.filter(q => q.tag === selectedTag)
      
  // const callCOntact = () => {
  //   navigate('/contact')
  //   window.scrollTo(0, 0)
  // }
  return (
    <section
      id='about'
      className='h-[80vh]  faq-screen mobile:mt-[100px] tablet:mt-[100px]  bg-[#EBF4FF] shadow-[0px_0px_8px_0px_rgba(0,_0,_0,_0.12)] inset rounded-[30px] mobile:h-[80vh] py-16 px-8 mobile:py-4 tablet:h-full'
    >
      <div className='flex flex-row items-center text-[#215998] mobile:text-[10px] '>
        <p className='mobile:text-[10px]'>06 / 06</p>
        <p className='ml-8 text-[#215998] gap-2'>|</p>
        <p className='ml-8 uppercase text-[36px] font-extrabold mobile:text-[12px] tablet:text-[30px]'>
          Түгээмэл асуулт хариултууд
        </p>
      </div>
      <div className='flex items-start gap-[0.75rem] md:flex-row mt-10 mobile:flex-col '>
        <div className='w-5/6 mobile:w-full temp:w-full tablet:w-full'>
          <div className='flex flex-row justify-start mb-10 mobile:hidden '>
            {tags.map(item => (
              <button
                key={item.name}
                onClick={() => setSelectedTag(item.name)}
                className={`px-4 py-2 rounded-[10px] ml-5 text-[11px] flex    justify-center 
                  items-center mobile:ml-2 mobile:px2 ${
                    selectedTag === item.name
                      ? 'bg-[#215998] text-white'
                      : 'bg-white text-[#215998]'
                  }`}
              >
                <img
                  src={selectedTag === item.name ? item.img : item.img2}
                  alt='Arrow Down'
                  className='h-[16px] w-[16px]'
                  style={{ marginRight: 10 }}
                />
                {item.name}
              </button>
            ))}
          </div>
          <div
            className='overflow-y-auto h-[50vh] mobile:h-[70vh] w-full mobile:w-full'
            // style={{ scrollbarWidth: "thin", scrollbarColor:"#EBF4FF white" }}
            style={{
              scrollbarWidth: 'thin',
              scrollbarColor: '#EBF4FF #215998 ',
              WebkitOverflowScrolling: 'touch',
              touchAction: 'auto'
            }}
          >
            <Suspense fallback={<div>Loading feed...</div>}>
              {filteredQuestions.map((item, index) => (
                <QuestionDetail
                  question={item.question}
                  answer={item.answer}
                  tags={tags}
                  key={'listloremipsumd' + index}
                  isOpen={openQuestionIndex === index}
                  onToggle={() => handleToggle(index)}
                />
              ))}
            </Suspense>
          </div>
        </div>

        <div className='bg-white flex flex-col items-center justify-start self-stretch ml-20 p-5 rounded-lg h-full  mobile:hidden tablet:hidden temp:hidden'>
          <div className='h-[60px] flex justify-center relative shrink-0 mobile:h-[40px] mobile:w-[80px] '>
            <img src={avatar} alt='Avatar' />
          </div>

          <p className='text-center text-[22px] mt-5 mb-5 font-semibold '>
            Танд тулгамдаж буй ямар асуудал байна?
          </p>

          <p className='text-center mobile:text-[14px]'>
            Манай баг хамт олон таны асуултын хариултыг өгөх болно
          </p>
          {/* <button>send message</button> */}
          {/* <TawkChat /> */}
        </div>
      </div>
    </section>
  )
}

export default FAQSection
